var _defs, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack114({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 13.31,
    rx: 7,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.8,13,8,1.19,1.2,13a.51.51,0,0,0-.2.35c0,.83,3.13,1.5,7,1.5s7-.67,7-1.5A.51.51,0,0,0,14.8,13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack114);
export default __webpack_public_path__ + "static/media/Symbolpack_1_14.dfec465ed6ecaae0e897cda59c0c78d4.svg";
export { ForwardRef as ReactComponent };